import {
    apiRequest,
    salaryCreate,
    pangkatList
} from "../../../../../services/adapters/master/salaryService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", salaryCreate, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", pangkatList, {
            params: query
        }, true)
    }
}

export default CreateRepository